import React from 'react';
import { Grid } from '@mui/material';
import DefaultSelectClient from '../../../components/default-select-client';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { GridPanel } from '../../../components/list-grid-panel';
import IrpDataTable from './components/irp-data-table';
import { useIrpSearchController } from './context/irp-search-controller';
import { useIrpSearchState } from './context/irp-search-context';
import { toLookupOptions } from '../shared/lookup-select';
import { buildSortOptions, toSortValue } from '../shared/scp-utils';
import { IrpSortField } from '../../../model/scp/irp/irp-sort-field';

const IRP_SORT_OPTIONS = buildSortOptions([
    { field: IrpSortField.UpdatedDate, label: 'Data de Alteração' },
    { field: IrpSortField.CreatedDate, label: 'Data de Criação' },
    { field: IrpSortField.NumberIrp, label: 'Número' },
    { field: IrpSortField.ProcessNumber, label: 'Nº Processo' },
    { field: IrpSortField.Year, label: 'Exercício' },
    { field: IrpSortField.Object, label: 'Objeto' },
    { field: IrpSortField.Modality, label: 'Modalidade' },
    { field: IrpSortField.ManagingUnit, label: 'Unidade Gerenciadora' },
]);

export function IrpSearchComponent() {
    const ctrl = useIrpSearchController();
    const { modality, parameters, searchTrigger } = useIrpSearchState();

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Intenção de Registro de Preço"
                    subtitle="Pesquise e gerencie as intenções de registro de preço"
                    breadcrumbs={[{ label: 'Intenção de Registro de Preço' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={6}>
                        <FilterInput label="Buscar por" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterSelect label="Ordenar por" name="select-sort" value={toSortValue(parameters.sortBy, parameters.sortDirection)} options={IRP_SORT_OPTIONS} onChange={ctrl.handleOnChange} emptyLabel="Padrão" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterInput label="Exercício" name="input-year" type="number" value={parameters.year} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FilterSelect label="Modalidade" name="select-modality" value={parameters.modalityId} options={toLookupOptions(modality)} onChange={ctrl.handleOnChange} emptyLabel="Todas" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DefaultSelectClient required={false} clientId={parameters.clientId} handleOnChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Nova intenção de registro de preço" onAdd={ctrl.navigateToCreate}>
                    <IrpDataTable
                        parameters={parameters}
                        searchTrigger={searchTrigger}
                        onPaginationChange={ctrl.handlePaginationChange}
                        onEdit={ctrl.navigateToEdit}
                        onDelete={ctrl.handleDelete}
                    />
                </GridPanel>
            </Grid>
        </React.Fragment>
    );
}
